import * as React from 'react';

import { getRangeValue } from '../../../../../JsonQuery';
import { BedroomsNew } from '../../../components/advancedFilters/BedroomsNew';
import { EBedrooms } from '../../../types/bedrooms';
import { useContext } from '../../../utils/useContext';

const MAP_GTE_TO_ENUM: Record<number, EBedrooms> = {
  1: EBedrooms.OneAndMore,
  2: EBedrooms.TwoAndMore,
  3: EBedrooms.ThreeAndMore,
  4: EBedrooms.FourAndMore,
  5: EBedrooms.FiveAndMore,
};

const MAP_ENUM_TO_GTE: Record<EBedrooms, number> = {
  [EBedrooms.OneAndMore]: 1,
  [EBedrooms.TwoAndMore]: 2,
  [EBedrooms.ThreeAndMore]: 3,
  [EBedrooms.FourAndMore]: 4,
  [EBedrooms.FiveAndMore]: 5,
};

export const BedroomsNewContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();

  const value = React.useMemo(() => {
    const bedrooms = getRangeValue('bedroom_total')(jsonQuery);

    if (!bedrooms || !bedrooms.gte) {
      return null;
    }

    return MAP_GTE_TO_ENUM[bedrooms.gte];
  }, [jsonQuery]);

  const handleBedroomsChange = React.useCallback(
    (bedrooms: EBedrooms | null) => {
      const minBedroomsCount = bedrooms ? MAP_ENUM_TO_GTE[bedrooms] : null;

      onChange(
        { action: 'setBedroomsCountMin', arguments: [minBedroomsCount] },
        { action: 'setBedroomsCountMax', arguments: [null] },
      );
    },
    [onChange],
  );

  return <BedroomsNew value={value} onChange={handleBedroomsChange} />;
};
